"use client";

import { cn } from "@dc/ui/lib/utils";
import Image from "next/image";
import { useState } from "react";

/**
 * Shared illustration panel for auth pages (login, signup, register).
 */
export const AuthVideoPanel = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <section className="relative hidden flex-1 items-center justify-center overflow-hidden bg-bg-container-page p-4 md:flex">
      <div
        className="absolute inset-0 bg-auto bg-repeat"
        style={{
          backgroundImage: "url('/auth/topo-map.png')",
        }}
      />
      <div className="relative flex w-full items-center justify-center px-8">
        <Image
          src="/auth/marketing-image-login.png"
          alt="Screenshot of Project Assist: AI analyzes construction subcontracts and specs and shows cited source documents."
          aria-hidden="true"
          loading="lazy"
          width={600}
          height={600}
          className={cn(
            "w-full max-w-xs object-contain md:max-w-xl lg:max-w-2xl xl:max-w-3xl",
            isLoaded ? "opacity-100 blur-0" : "opacity-0 blur-md",
          )}
          style={{
            transition: "opacity 700ms ease-out, filter 900ms cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onLoad={() => setIsLoaded(true)}
        />
      </div>
    </section>
  );
};
